import { Card, Paper } from "@mui/material";
import { experimentalStyled as styled } from "@mui/material/styles";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.secondary,
  textAlign: "left",
}));
function AboutUs(){
     
        return <Item style={{display:'flex', width:'60vw', margin:'auto',marginTop:"2%"}}>
   
        <p style={{margin:'auto',width:'60vw'}}>

        Boekhoudkantoor A-Census zorgt voor het correct bijhouden van uw boekhouding en het tijdig indienen van alle fiscale aangiftes. We streven er elke dag naar om onze klanten zo goed mogelijk te begeleiden. Adviesverlening op maat en in verstaanbare verwoordingen is voor ons van groot belang.
Door onze persoonlijke aanpak en kennis van uw dossier, kunnen we een uitstekende begeleiding en ondersteuning bieden, waardoor we een betrouwbare partner zijn voor uw onderneming.
We richten ons op (lokale) ondernemers, zelfstandigen en (kleine) vennootschappen, vrije beroepen en VZW’s.

        </p>

      </Item>
    

}

export default AboutUs